<template>
  <div class="operate-release-flow-add">
    <Card shadow class="content">
      <div class="main">
       <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
        <Row class="title">
          <h4 :style="{float: 'left'}">申请资产报废</h4>
        </Row>
        <!-- <GeneralAlert></GeneralAlert> -->
        <Form inline :label-width="100" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
          <!-- <Col span="24">
              <FormItem label="残值" style="width: 100%" prop="scrap_value">
                <RadioGroup v-model="baseInfo.scrap_value" type="button">
                  <Radio :label="0">小于10万元</Radio>
                  <Radio :label="1">大于10万元</Radio>
                </RadioGroup>
              </FormItem>
            </Col> -->
            <Col span="24">
              <FormItem label="资产类型" style="width: 100%" prop="type">
                 <RadioGroup v-model="baseInfo.type" @on-change="onSelectPm">
                    <radio v-for="envModeItem in all_type_list" :key="envModeItem.key" :label="envModeItem.key">{{ envModeItem.label }}</radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
           <Row>
             <Col span="24">
              <FormItem :label="'报废资产(' + baseInfo.targetsLength + ')'" :label-width="100" prop="targetsLength">
                <Tag color="primary" v-for="(tValue, tKey, tIndex) in baseInfo.assets_d" :key="'target_asset_' + tIndex" v-if="tValue">{{ tKey }}</Tag>
                <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal()" v-if="!baseInfo.targetsLength">选择要报废的资产</Button>
                <a v-on:click="openSelectServerModal()" v-else>继续选择要报废的资产 </a>
              </FormItem>
               </Col>
          </Row>
           <Row>
            <Col span="24">
              <FormItem
                  v-if="baseInfo.type"
                  v-for="(item, index) in baseInfo.steps"
                  :key="index"
                  :label="item.name"
                  :prop="'steps.' + index + '.users_sel'"
                  :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
              <i-select v-model="item.users_sel" filterable multiple disabled>
                <i-option v-for="user in item.users" :value="user.username" :key="user.id" :label="user.name"></i-option>
              </i-select>
            </FormItem>
          </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createOperateReleaseFlow, getOpsTypeReleaseSteps, getAllOpsFLowTypes } from '@/api/cmdb'
import { forEach } from '@/libs/tools'
import SelectServer from '../components/select-server'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'edit',
  components: {
    SelectServer
  },
  data () {
    return {
      pm_visible: false,
      all_user_list: [],
      all_type_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        flow_object: '1',
        title: '',
        assets: [],
        assets_d: {},
        targetsLength: 0,
        scrap_value: '',
        type: null,
        steps: [
          {
            id: null,
            name: null,
            users: [],
            users_sel: []
          }
        ]
      },
      version: {},
      baseInfoFormRules: {
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        type: { required: true, message: '请选择流程类型', type: 'number', trigger: 'change' },
        targetsLength: [
          { required: true, type: 'number', validator: this.validArrayRule, min: 1, message: '请选择要报废的资产', trigger: 'change' }
        ]
      },
      moduleList: [],
      submitting: false
    }
  },
  mounted: function () {
    // this.getModuleList()
    // this.fetchStepsData()
    // this.getAllUsersData()
    this.getAllOpsTypes()
  },
  // watch: {
  //   '$store.state.user.defaultTenant' () {
  //     this.fetchStepsData()
  //     // this.getModuleList()
  //   }
  // },
  methods: {
    // 数组校验器
    validArrayRule (rule, value, callback) {
      if (value === 0) {
        callback(new Error())
      } else {
        callback()
      }
    },
    // 选择服务器完成回调
    selectServerComplete (server, length) {
      console.log(server)
      this.baseInfo.assets_d = server
      this.baseInfo.targetsLength = length
    },
    // 打开资产选择Modal
    openSelectServerModal () {
      if (this.baseInfo.type) {
        this.$refs.SelectServer.openSelectServerModal({}, this.baseInfo.assets_d, false, this.baseInfo.type, '1')
      } else {
        this.$Message['error']({
          background: true,
          content: '请先选择要报废的资产类型',
          duration: 5
        })
      }
    },
    onSelectPm (value) {
      this.baseInfo.assets_d = {}
      this.baseInfo.targetsLength = 0
      this.fetchStepsData()
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有类型列表
    getAllOpsTypes () {
      this.all_type_list = []
      let params = {
      }
      getAllOpsFLowTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': '产品组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    fetchStepsData () {
      console.log(1111)
      this.baseInfo.steps = []
      let data = {
        type_id: this.baseInfo.type,
        flow_object: '1'
      }
      getOpsTypeReleaseSteps(data).then(res => {
        if (res.data.data instanceof Array && res.data.data.length > 0) {
          this.baseInfo.steps = res.data.data
          this.baseInfo.steps.map(item => {
            item.users_sel = item.users.map(j => j.username)
          })
          console.log(this.baseInfo.steps)
        }
      })
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        this.baseInfo.enclosure = res
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 提交
    submit () {
      this.baseInfo.assets = []
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          forEach(this.baseInfo.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            this.baseInfo[stepName] = item.users_sel
          })
          for (let asset in this.baseInfo.assets_d) {
            this.baseInfo.assets.push(this.baseInfo.assets_d[asset])
          }
          this.submitting = true
          createOperateReleaseFlow(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'asset_scrap_detail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .operate-release-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
